import { render, staticRenderFns } from "./section-features.vue?vue&type=template&id=a6cee51e&scoped=true"
import script from "./section-features.vue?vue&type=script&lang=js"
export * from "./section-features.vue?vue&type=script&lang=js"
import style0 from "./section-features.vue?vue&type=style&index=0&id=a6cee51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cee51e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
